import { Box } from '@mantine/core';
import { clearNotifications, setTalentFilter, selectTalents } from 'modules/Talent/talentSlice';
import { connect, useDispatch } from 'react-redux';
import { Route, Routes } from 'react-router-dom';
import { showNotification } from '@mantine/notifications';
import { useEffect } from 'react';

import { logger } from 'utils/logger';
import Talents from './features/talents/Talents';
import Talent from './features/talent/Talent';

const TalentModule = ({ user, guide, guides, selectedTalent, success, error, setTalentFilter, talentFilter }) => {
    const dispatch = useDispatch();

    // SUCCESS AND ERROR HANDLERS
    useEffect(() => {
        logger.log(success);
        if (error) {
            showNotification({
                title: 'Whoops something went wrong.',
                message: error.message,
                position: 'top-center',
                color: 'red',
            });

            dispatch(clearNotifications());
        }

        if (success) {
            switch (success.type) {
                
                default: {
                    break;
                }
            }
        }

        // if the session has been created then we load the session detail view
    }, [error, success, dispatch, clearNotifications]);

    return (
        <Box
            id='talentModule'
            className="module-container"
            >
            
                <Routes>
                    <Route path='/' element={<Talents />}></Route>
                    <Route path='/:id' element={<Talent />}></Route>
                </Routes>
            
        </Box>
    );
};

const mapStateToProps = (state, props) => {
    //logger.log(state,props, ' mapstate')
    return {
        user: state.auth.user,
        talentFilter: state.talentReducer.talentFilter,
        selectedTalents: state.talentReducer.selectedTalents,
        talent: state.talentReducer.selectedTalent,
        success: state.talentReducer.success,
        displayPrefs: state.talentReducer.displayPrefs,
        error: state.talentReducer.error,
    };
};

const mapDispatchToProps = { setTalentFilter, selectTalents };

export default connect(mapStateToProps, mapDispatchToProps)(TalentModule);
